import React, { useState } from "react";
import theme from "../../../styles/theme";

const DropdownAdvanced = ({
  label,
  options = [],
  selectedValues = [],
  onChange,
  placeholder = "Sélectionnez...",
  disabled = false,
  showSelectAll = true,
}) => {
  const [open, setOpen] = useState(false);

  const toggleOption = (value) => {
    if (disabled) return;
    const newSelected = selectedValues.includes(value)
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value];
    onChange(newSelected);
  };

  const handleSelectAll = () => {
    if (selectedValues.length === options.length) {
      onChange([]); // Désélectionne tout
    } else {
      onChange(options.map((opt) => opt.value)); // Sélectionne tout
    }
  };

  return (
    <div style={{ marginBottom: theme.spacing.md, position: "relative" }}>
      {/* Label au-dessus */}
      {label && (
        <label
          style={{
            display: "block",
            marginBottom: theme.spacing.xs,
            fontSize: theme.fontSizes.sm,
            fontFamily: theme.fonts.primary,
            color: theme.colors.text.default,
          }}
        >
          {label}
        </label>
      )}

      {/* Bouton principal */}
      <div
        onClick={() => !disabled && setOpen(!open)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
          borderRadius: theme.borders.radius.sm,
          border: `1px solid ${theme.colors.borders.default}`,
          backgroundColor: disabled
            ? theme.buttons.disabled.background
            : theme.colors.background.input,
          cursor: disabled ? "not-allowed" : "pointer",
          fontFamily: theme.fonts.primary,
          color: theme.colors.text.default,
        }}
      >
        <span>
          {selectedValues.length > 0
            ? selectedValues
                .map((val) => {
                  const opt = options.find((o) => o.value === val);
                  return opt ? opt.label : val;
                })
                .join(", ")
            : placeholder}
        </span>
        <span style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}>▼</span>
      </div>

      {/* Liste déroulante */}
      {open && !disabled && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            maxHeight: "220px",
            overflowY: "auto",
            border: `1px solid ${theme.colors.borders.default}`,
            borderRadius: theme.borders.radius.sm,
            backgroundColor: theme.colors.background.surface,
            boxShadow: theme.shadows.md,
            zIndex: 10,
            marginTop: "2px",
          }}
        >
          {/* Checkbox "Tout sélectionner" */}
          {showSelectAll && options.length > 0 && (
            <div
              onClick={handleSelectAll}
              style={{
                display: "flex",
                alignItems: "center",
                gap: theme.spacing.sm,
                padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
                borderBottom: `1px solid ${theme.colors.borders.default}`,
                cursor: "pointer",
                backgroundColor:
                  selectedValues.length === options.length
                    ? theme.colors.background.muted
                    : "transparent",
              }}
            >
              <input
                type="checkbox"
                checked={selectedValues.length === options.length}
                readOnly
                style={{
                  cursor: "pointer",
                  accentColor: theme.buttons.green.background,
                }}
              />
              <span style={{ fontWeight: "bold", color: theme.colors.text.default }}>
                Tout sélectionner
              </span>
            </div>
          )}

          {/* Options */}
          {options.map((opt) => (
            <div
              key={opt.value}
              onClick={() => toggleOption(opt.value)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: theme.spacing.sm,
                padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
                cursor: "pointer",
                backgroundColor: selectedValues.includes(opt.value)
                  ? theme.colors.background.muted
                  : "transparent",
                color: theme.colors.text.default,
                transition: "background-color 0.2s",
              }}
            >
              <input
                type="checkbox"
                checked={selectedValues.includes(opt.value)}
                readOnly
                style={{
                  cursor: "pointer",
                  accentColor: theme.buttons.green.background,
                }}
              />
              <span>{opt.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownAdvanced;
